import type { ModStatus } from '@/api/generated/schemas';

export type StatusTone = 'success' | 'warning' | 'error';

/** A missing file is amber, not red: it is a fact, not a moderation call. */
export const statusTone = (modStatus: ModStatus | null): StatusTone => {
  if (modStatus == null) return 'warning';
  if (modStatus === 'enabled') return 'success';
  return modStatus === 'test' ? 'warning' : 'error';
};
